/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConnectStationDto } from '../models';
// @ts-ignore
import type { CreateStationDto } from '../models';
// @ts-ignore
import type { StationDetailsDto } from '../models';
// @ts-ignore
import type { StationListDto } from '../models';
// @ts-ignore
import type { StationResponseDto } from '../models';
/**
 * StationApi - axios parameter creator
 * @export
 */
export const StationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Connect a payment terminal to a station
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectStatationTerminal: async (connectStationDto: ConnectStationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectStationDto' is not null or undefined
            assertParamExists('connectStatationTerminal', 'connectStationDto', connectStationDto)
            const localVarPath = `/api/v1/station/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectStationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new station
         * @param {CreateStationDto} createStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStation: async (createStationDto: CreateStationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStationDto' is not null or undefined
            assertParamExists('createStation', 'createStationDto', createStationDto)
            const localVarPath = `/api/v1/station/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete (deactivate) a station
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStation', 'id', id)
            const localVarPath = `/api/v1/station/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect a payment terminal from a station
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectStationTerminal: async (connectStationDto: ConnectStationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectStationDto' is not null or undefined
            assertParamExists('disconnectStationTerminal', 'connectStationDto', connectStationDto)
            const localVarPath = `/api/v1/station/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectStationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all stations by business ID
         * @param {string} businessId 
         * @param {GetAllStationsByBusinessIdTypeEnum} [type] Filter stations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStationsByBusinessId: async (businessId: string, type?: GetAllStationsByBusinessIdTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('getAllStationsByBusinessId', 'businessId', businessId)
            const localVarPath = `/api/v1/station/{businessId}`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hard delete a station
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteStation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hardDeleteStation', 'id', id)
            const localVarPath = `/api/v1/station/hard-delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing station
         * @param {string} id 
         * @param {CreateStationDto} createStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStation: async (id: string, createStationDto: CreateStationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateStation', 'id', id)
            // verify required parameter 'createStationDto' is not null or undefined
            assertParamExists('updateStation', 'createStationDto', createStationDto)
            const localVarPath = `/api/v1/station/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StationApi - functional programming interface
 * @export
 */
export const StationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Connect a payment terminal to a station
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectStatationTerminal(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectStatationTerminal(connectStationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.connectStatationTerminal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new station
         * @param {CreateStationDto} createStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStation(createStationDto: CreateStationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStation(createStationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.createStation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete (deactivate) a station
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.deleteStation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disconnect a payment terminal from a station
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectStationTerminal(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectStationTerminal(connectStationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.disconnectStationTerminal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all stations by business ID
         * @param {string} businessId 
         * @param {GetAllStationsByBusinessIdTypeEnum} [type] Filter stations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllStationsByBusinessId(businessId: string, type?: GetAllStationsByBusinessIdTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllStationsByBusinessId(businessId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.getAllStationsByBusinessId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hard delete a station
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hardDeleteStation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hardDeleteStation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.hardDeleteStation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing station
         * @param {string} id 
         * @param {CreateStationDto} createStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStation(id: string, createStationDto: CreateStationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStation(id, createStationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.updateStation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StationApi - factory interface
 * @export
 */
export const StationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StationApiFp(configuration)
    return {
        /**
         * 
         * @summary Connect a payment terminal to a station
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectStatationTerminal(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig): AxiosPromise<StationDetailsDto> {
            return localVarFp.connectStatationTerminal(connectStationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new station
         * @param {CreateStationDto} createStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStation(createStationDto: CreateStationDto, options?: RawAxiosRequestConfig): AxiosPromise<StationResponseDto> {
            return localVarFp.createStation(createStationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete (deactivate) a station
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStation(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StationResponseDto> {
            return localVarFp.deleteStation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect a payment terminal from a station
         * @param {ConnectStationDto} connectStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectStationTerminal(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.disconnectStationTerminal(connectStationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all stations by business ID
         * @param {string} businessId 
         * @param {GetAllStationsByBusinessIdTypeEnum} [type] Filter stations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStationsByBusinessId(businessId: string, type?: GetAllStationsByBusinessIdTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<StationListDto> {
            return localVarFp.getAllStationsByBusinessId(businessId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hard delete a station
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteStation(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StationResponseDto> {
            return localVarFp.hardDeleteStation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing station
         * @param {string} id 
         * @param {CreateStationDto} createStationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStation(id: string, createStationDto: CreateStationDto, options?: RawAxiosRequestConfig): AxiosPromise<StationResponseDto> {
            return localVarFp.updateStation(id, createStationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StationApi - object-oriented interface
 * @export
 * @class StationApi
 * @extends {BaseAPI}
 */
export class StationApi extends BaseAPI {
    /**
     * 
     * @summary Connect a payment terminal to a station
     * @param {ConnectStationDto} connectStationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public connectStatationTerminal(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).connectStatationTerminal(connectStationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new station
     * @param {CreateStationDto} createStationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public createStation(createStationDto: CreateStationDto, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).createStation(createStationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete (deactivate) a station
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public deleteStation(id: string, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).deleteStation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect a payment terminal from a station
     * @param {ConnectStationDto} connectStationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public disconnectStationTerminal(connectStationDto: ConnectStationDto, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).disconnectStationTerminal(connectStationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all stations by business ID
     * @param {string} businessId 
     * @param {GetAllStationsByBusinessIdTypeEnum} [type] Filter stations by type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public getAllStationsByBusinessId(businessId: string, type?: GetAllStationsByBusinessIdTypeEnum, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).getAllStationsByBusinessId(businessId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hard delete a station
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public hardDeleteStation(id: string, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).hardDeleteStation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing station
     * @param {string} id 
     * @param {CreateStationDto} createStationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public updateStation(id: string, createStationDto: CreateStationDto, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).updateStation(id, createStationDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllStationsByBusinessIdTypeEnum = {
    KIOSK: 'KIOSK',
    POS: 'POS'
} as const;
export type GetAllStationsByBusinessIdTypeEnum = typeof GetAllStationsByBusinessIdTypeEnum[keyof typeof GetAllStationsByBusinessIdTypeEnum];
